var React = require('react');

function PaperClip (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null)),React.createElement("title",{"key":1},"attachment"),React.createElement("path",{"className":"cls-1","d":"M249.87,171l-70.79,70.8a25.05,25.05,0,0,1-35.43-35.43l87.89-87.89A45.59,45.59,0,0,1,296,183l-92.5,92.5A66.13,66.13,0,0,1,110,182l64.56-64.56","key":2})]);
}

PaperClip.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 400 400"};

module.exports = PaperClip;

PaperClip.default = PaperClip;
